import React, { useState, useEffect } from 'react';
import { MainHeader } from '.';
import { useParams } from 'react-router-dom';
import postContactRequest from '../../../ApiV2/postContactRequest'

import getGolfTargets from '../../../ApiV2/getGolfTargets';
import DefaultModal from '../Modals/DefaultModal';

let CartRequest = () => {
  const { location } = useParams();
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState("");
  const [cartNumber, setCartNumber] = useState("");
  const [area, setArea] = useState("");
  const [itemRequested, setItemRequested] = useState("");
  const [notes, setNotes] = useState("");
  const [modalMessage, setModalMessage] = useState(true);
  const [formStatus, setFormStatus] = useState('Send');
  const [show, setShow] = useState(false);
  const [golfTargets, setGolfTargets] = useState([]);
  const [selectedTarget, setSelectedTarget] = useState("");

useEffect(() => {
    console.log(location)
      getGolfTargets(location)
        .then(response => {
          response.json().then(data => ({
            data: data,
            status: response.status
          }))
            .then(jsonResponse => {
              console.log(jsonResponse.data)
              // TODO: Cache golf targets data with getCachedResponse/cacheAPIResponse
              setGolfTargets(jsonResponse.data);
            })
        })
        .catch((error) => {
          console.log(error);
        })
    
  }, [])







  const onSubmit = (e) => {
    e.preventDefault();
    
    // Validate required fields (cartNumber is required and must be numeric)
    if (!name || !selectedTarget || !area || !itemRequested || !cartNumber) {
      alert("Please fill in all required fields");
      return;
    }

    if (!/^\d+$/.test(cartNumber)) {
      alert("Cart number must be numeric");
      return;
    }

    setLoading(true);
    setFormStatus('Submitting...');
    let requestData = {
      CustomerName: name,
      CartNumber: cartNumber,
      Area: area,
      itemRequested: itemRequested,
      notes: notes
    }
    console.log(requestData)

    postContactRequest(location, selectedTarget, requestData)
      .then(response => {
        if(!response.ok) {
          throw new Error(`HTTP Error: ${response.status} - ${response.statusText}`);
        }
        return response;
      })
      .then(() => {
        setFormStatus('Send');
        setName("");
        setCartNumber("");
        setArea("");
        setItemRequested("");
        setNotes("");
        setSelectedTarget("");
        setLoading(false);
        setModalMessage(true);
        setShow(true);
      })

      .catch((error) => {
        console.error("Error submitting cart request:", error);
        setLoading(false);
        setFormStatus('Send');
        setModalMessage(false);
        setShow(true);
        alert(`Error submitting request: ${error.message || "Unknown error occurred"}`);
      })

  }



  return (
    <>
      <MainHeader />
      <div className="space-on-bottom">
        <div className="menu-background-section">
        <h2 className="mb-3">Cart Request </h2>
        <form onSubmit={onSubmit}>
          <div className="mb-3">
            <label className="form-label" htmlFor="name" >
              Name
            </label>
            <input className="form-control" placeholder="Enter your name" type="text" id="name" value={name} onChange={(e) => setName(e.target.value)} style={{textAlign: 'center'}} required />
          </div>
          <div className="mb-3">
            <label className="form-label" htmlFor="target">
              Select General Area
            </label>
            <select className="form-control" id="target" value={selectedTarget} onChange={(e) => setSelectedTarget(e.target.value)} style={{textAlign: 'center'}} required>
              <option value="">Select a target area</option>
              {golfTargets.map((target) => (
                <option key={target.requestTargetGUID} value={target.requestTargetGUID}>
                  {target.areaName}
                </option>
              ))}
            </select>
          </div>
          <div className="mb-3">
            <label className="form-label" htmlFor="cartNumber">
              Cart Number
            </label>
            <input
              className="form-control"
              placeholder="Enter cart number"
              type="number"
              inputMode="numeric"
              pattern="\d*"
              id="cartNumber"
              value={cartNumber}
              onChange={(e) => setCartNumber(e.target.value.replace(/\D/g, ''))}
              style={{textAlign: 'center'}}
              required
            />
          </div>
          <div className="mb-3">
            <label className="form-label" htmlFor="area">
              Closest Hole 
            </label>
            <select className="form-control" id="area" value={area} onChange={(e) => setArea(e.target.value)} style={{textAlign: 'center'}} required>
              <option value="">Select a hole</option>
              {Array.from({length: 18}, (_, i) => i + 1).map((areaNum) => (
                <option key={areaNum} value={areaNum}>
                  {areaNum}
                </option>
              ))}
            </select>
          </div>
          <div className="mb-3">
            <label className="form-label" htmlFor="itemRequested">
              Requested Item
            </label>
            <input className="form-control" type="text" id="itemRequested" placeholder="Enter Desired Beer or Food (if available)" value={itemRequested} onChange={(e) => setItemRequested(e.target.value)} style={{textAlign: 'center'}} required />
          </div>
          <div className="mb-3">
            <label className="form-label" htmlFor="notes">
              Notes
            </label>
            <textarea className="form-control" id="notes" value={notes} onChange={(e) => setNotes(e.target.value)} style={{textAlign: 'center'}} rows="3"></textarea>
          </div>
          <button className="submit-button" disabled={loading} type="submit">
            {formStatus}
          </button>
        </form>
        </div>
      </div>
      <DefaultModal show={show} successMessage={modalMessage} handleClose={()=>setShow(false)} customSuccessMessage="We will have someone send a cart out shortly" />
    </>
  );
}

export default CartRequest;